var React = require('react');

function CalculatorIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(5100.583 3472)"},React.createElement("path",{"className":"primary-fill","d":"M53.986,2H15.264A6.136,6.136,0,0,0,9,8.067V55.936A6.136,6.136,0,0,0,15.264,62H53.986a6.137,6.137,0,0,0,6.264-6.064V8.067A6.138,6.138,0,0,0,53.986,2ZM25.875,53.25H17.75V48.875h8.125Zm0-8.125H17.75V40.75h8.125Zm0-8.75H17.75V32h8.125ZM39,53.25H30.25V48.875H39Zm0-8.125H30.25V40.75H39Zm0-8.75H30.25V32H39ZM51.5,53.25H43.375V48.875H51.5Zm0-8.125H43.375V40.75H51.5Zm0-8.75H43.375V32H51.5ZM54,21.732a2.143,2.143,0,0,1-2.143,2.143H17.393a2.143,2.143,0,0,1-2.143-2.143V12.893a2.143,2.143,0,0,1,2.143-2.143H51.858A2.143,2.143,0,0,1,54,12.893Z"})));
}

CalculatorIcon.defaultProps = {"viewBox":"5109 3474 52 60","className":"calculator icon"};

module.exports = CalculatorIcon;

CalculatorIcon.default = CalculatorIcon;
